// extracted by mini-css-extract-plugin
export default {"generateTestData":"generateTestData-Jz_NZ","formContainer":"formContainer-pvx_a","configForm":"configForm-zfmvo","footer":"footer-fdgmt","button":"button-nsFFY"};